/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Gate_Desc_Audit_LogsInputs */



/**
* | output |
* | --- |
* | "Track all user actions and AI interactions for EU AI Act compliance." |
*
* @param {Plan_Gate_Desc_Audit_LogsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_desc_audit_logs = /** @type {((inputs?: Plan_Gate_Desc_Audit_LogsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Desc_Audit_LogsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verfolgen Sie alle Benutzeraktionen und KI-Interaktionen für die EU-KI-Verordnung.")
	return /** @type {LocalizedString} */ ("Track all user actions and AI interactions for EU AI Act compliance.")
});